import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import "./Footer.css";
import moment from "moment";

const Footer = (props) => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={12} lg={6} className='footerfontposition'>
            {/* <span className="footerproducttable footerfontsize">Powered by</span> */}
                {/* <a
                  className="gtrendz-text footercopyright"
                  href="https://bechofy.in"
                  target="_blank"
                >
                  <span className="footerproductonhovertable footerfontsize"> Bechofy</span>
                  <span className="footerproducttable footerfontsize"> - </span>
                </a> */}

                <span className="footerproducttable footerfontsize">
                Design
                  <a
                    className="gtrendz-text footercopyright"
                    href="http://globaltrendz.com/"
                    target="_blank"
                  >
                    <span className="footerproductonhovertable footerfontsize"> Global Trendz</span>
                  </a>
                </span>
            </Col>
            <Col md={12} lg={6} className='footerfontposition'>
              {/* <div className="text-sm-center d-none d-sm-block"> */}
              <div className="text-lg-right d-none d-sm-block">
                {/* {new Date().getFullYear()} © Global Trendz. All rights reserved */}

                <p className='footerproducttable footerfontsize'>
                  Copyright© {moment().format("YYYY")} Kalanjiam Hardware
                  Store. All Rights Reserved.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
